document.addEventListener('DOMContentLoaded', function () {
	const languageTabsBlocks = document.querySelectorAll(
		'.wp-block-mayakempe-plus-language-tabs',
	);

	languageTabsBlocks.forEach((tabsBlock) => {
		const tabs = tabsBlock.querySelectorAll('[data-language]');
		const tabButtons = new Map();

		// Create tab buttons dynamically
		const tabNavigation = document.createElement('div');
		tabNavigation.className = 'mayakempe-language-tabs-nav';

		tabs.forEach((tab, index) => {
			const language = tab.getAttribute('data-language');
			const languageLabel =
				tab.getAttribute('data-language-label') || language.toUpperCase();

			const button = document.createElement('button');
			button.className = 'mayakempe-language-tab-button';
			button.textContent = languageLabel;
			button.setAttribute('data-language', language);

			if (index === 0) {
				button.classList.add('active');
				tab.classList.add('active');
			}

			button.addEventListener('click', function () {
				// Remove active class from all tabs and buttons
				tabs.forEach((t) => t.classList.remove('active'));
				tabsBlock
					.querySelectorAll('.mayakempe-language-tab-button')
					.forEach((btn) => btn.classList.remove('active'));

				// Add active class to clicked button and corresponding tab
				button.classList.add('active');
				tab.classList.add('active');
			});

			tabButtons.set(language, button);
			tabNavigation.appendChild(button);

			// Add separator except for last item
			if (index < tabs.length - 1) {
				const separator = document.createElement('span');
				separator.className = 'mayakempe-language-tab-separator';
				separator.textContent = '|';
				tabNavigation.appendChild(separator);
			}
		});

		// Insert navigation before the tabs content
		tabsBlock.insertBefore(tabNavigation, tabsBlock.firstChild);

		// Hide all tabs except the first one
		tabs.forEach((tab, index) => {
			if (index !== 0) {
				tab.classList.remove('active');
			}
		});
	});
});
